<template>
<div>
  <div id="wrapper" class="d-flex flex-column">
    <div class="page-loader-wrapper" v-if="isLoading">
      <div class="loader">
          <img src="./assets/logo6.png" alt="Lucid Logo" class="img-responsive logo" style="width:50px;height:60px">
               <link href="https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap" rel="stylesheet">
               <span style="margin-top:13px;margin-left:-5px;color:black; display:inline-block; font-family: 'Lato', sans-serif; font-size: 20px;">FaceScreen</span>  
          <p style="color:black">Please wait...</p>        
      </div>
    </div> 
    <HeaderComponent v-if="!isAuthPage" />
    <div v-if="logoutMessage.show" :class="logoutMessage.class" style="margin: 1rem; position: relative; padding: 1rem; border-radius: 5px;">
      <i class="fa fa-info-circle"></i>
      {{ logoutMessage.text }}
      <button @click="logoutMessage.show = false"
              style="position: absolute; top: 8px; right: 10px; background: none; border: none; font-size: 20px; cursor: pointer;">
        &times;
      </button>
    </div>
    <div class="w-100">
      <SidebarComponent v-if="!isAuthPage" />
      <router-view></router-view>
    </div>
    <FooterComponent v-if="!isAuthPage" />
  </div>
  
</div> 
  
</template>
<script>
import HeaderComponent from './components/admin/layouts/HeaderComponent.vue'
import SidebarComponent from './components/admin/layouts/SidebarComponent.vue'
import FooterComponent from './components/admin/layouts/FooterComponent.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    SidebarComponent,
    FooterComponent
  },
  
  computed: {
    isAuthPage() {
      const authPages = ['login', 'register', 'lockscreen', 'fpassword', 'rpassword', '404', '403', '500', '503', 'maintanance'];
      return authPages.includes(this.$route.name);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        document.body.className = this.$route.name === 'maintanance' ? '' : 'theme-cyan';

        const token = localStorage.getItem('userJWtoken');
        if (!this.isAuthPage && token) {
          this.setupActivityListeners();
          this.resetInactivityTimer();
        } else {
          this.removeActivityListeners();
          if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
        }
      }
    }
  },
  methods:{
    resetInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
      this.inactivityTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.timeoutLimit);
    },
    handleAutoLogout() {
      console.log("Logging out due to inactivity...");
      localStorage.removeItem("userJWtoken");
      this.removeActivityListeners();
      this.$router.push('/authentication/page-login');
      this.logoutMessage = {
        show: true,
        text: "You have been logged out due to 15 minutes of inactivity.",
        class: "alert alert-info"
      };
    },

    setupActivityListeners() {
      const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
      events.forEach(event => {
        window.addEventListener(event, this.resetInactivityTimer);
      });
    },
    removeActivityListeners() {
      const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
      events.forEach(event => {
        window.removeEventListener(event, this.resetInactivityTimer);
      });
    }
  },
  
  data (){
      return{
        isLoading: true,
        inactivityTimer:null,
        timeoutLimit:15 * 60 * 1000,
        logoutMessage: {
          show: false,
          text: '',
          class: ''
        }
      }
  },
  created(){
         this.interval = setInterval(() => {
            this.isLoading = false
        }, 3000);
    }
}
</script>
<style lang="scss">
  @import '../src/assets/vendor/bootstrap/css/bootstrap.min.css';
  @import '../src/assets/vendor/font-awesome/css/font-awesome.min.css';
  @import '../src/assets/scss/main.scss';
  @import '../src/assets/scss/color_skins.scss';
  @import '../node_modules/vue-multiselect/dist/vue-multiselect.css';
</style>
